module.exports = __webpack_public_path__ + "img/add-new-user-btn.f4b26cd4.png";